var _style, _g, _path, _g2, _g3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 7106 2462",
    style: {
      enableBackground: "new 0 0 7106 2462"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#474747;}\n\t.st1{fill:url(#SVGID_1_);}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M144.8,1077.2v-4c0-410.9,314.2-733.2,741.2-733.2c288,0,473.3,120.9,598.2,292l-294.1,227.6 C1109.6,761,1016.9,694.6,882,694.6c-197.4,0-336.4,169.2-336.4,374.6v4c0,211.5,139,376.7,336.4,376.7 c147,0,233.6-68.5,318.2-171.2l294.1,209.5c-132.9,183.3-312.2,318.2-622.4,318.2C469.1,1806.4,144.8,1498.2,144.8,1077.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M2321.9,368.3h390.8v1067.5h682.8v342.4H2321.9V368.3z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 4141.9058,
    y1: 1322.406,
    x2: 6939.6875,
    y2: 1322.406
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00D747"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#69D382"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M6221.3,372.3c-279.2,0-507.4,140.6-628.4,348.7c-115.3-198.2-293-321.9-529.1-368.3 c-28.8-5.6-58.1-8.5-87.1-12.7c-35,0-69.9,0-104.9,0c-26.9,3.6-54.1,6.2-80.8,11.1c-229.7,42.2-407,162.9-530.6,360.3 c-96.9,154.7-134.6,324.2-112.4,506c15.1,123.8,63.9,235.2,129.1,339.9c77,123.8,170.6,235,268.7,342.2 c123.2,134.5,248.5,267.1,372.9,400.5c1.7,1.8,4,3.1,6,4.6c2-1.7,3.4-2.6,4.5-3.7c134-143.1,269.2-285.1,401.5-429.8 c92.1-100.8,179.1-206.3,250.2-323.4c14.7-24.2,28.2-48.6,40.4-73c125.4,181,338.3,299.4,596.1,299.4c418.3,0,722.3-315.6,722.3-701 v-3.9C6939.7,684,6639.6,372.3,6221.3,372.3z M5371.4,1506.7c-107.7,91.3-255.9,166.1-447.4,166.1c-326.2,0-550.6-228.9-550.6-538.6 v-3c0-297.8,231.9-541.6,549.1-541.6c188.5,0,302.2,50.9,411.5,143.6l-145.1,175.1C5108.1,840.9,5036.2,802,4915,802 c-167.6,0-300.7,148.1-300.7,326.2v3c0,191.5,131.7,332.2,317.2,332.2c83.8,0,158.6-20.9,217-62.8v-149.6h-231.9v-199h454.9V1506.7z  M6627.9,1077.1c0,232.4-166.5,422.1-406.6,422.1c-240.1,0-410.5-193.6-410.5-426v-3.9c0-232.4,166.5-422.1,406.6-422.1 c240.1,0,410.5,193.6,410.5,426V1077.1z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M2064.2,637.9V368.3h-390.8V637C1803.5,637.3,1933.8,637.6,2064.2,637.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1673.4,894.1v884.1h390.8V638.5C1933.7,723.8,1803.5,809,1673.4,894.1z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M3965.4,637.9V368.3h-390.8V637C3704.8,637.3,3835,637.6,3965.4,637.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M3574.6,893.9v884.3h390.8V638.3C3835,723.6,3704.8,808.8,3574.6,893.9z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.8f922d9364c706920ceaf6c894a4f066.svg";
export { ForwardRef as ReactComponent };